if (!customElements.get('article-engagement')) {
  customElements.define(
    'article-engagement',
    class ArticleEngagement extends HTMLElement {
      connectedCallback() {
        this.likeButton = this.querySelector('[data-like-button]');
        this.likeCount = this.querySelector('[data-like-count]');
        this.shareButton = this.querySelector('[data-share-button]');
        this.storageKey = `article-liked:${this.dataset.shareUrl}`;

        if (this.likeButton) {
          this.baseCount = this.likeCount ? this.likeCount.textContent.trim() : '';
          this.setLiked(this.readLiked());
          this.likeButton.addEventListener('click', () => {
            const liked = this.likeButton.getAttribute('aria-pressed') !== 'true';
            this.setLiked(liked);
            try {
              liked ? localStorage.setItem(this.storageKey, '1') : localStorage.removeItem(this.storageKey);
            } catch (e) {}
          });
        }

        if (this.shareButton) {
          this.shareButton.addEventListener('click', this.share.bind(this));
        }
      }

      readLiked() {
        try {
          return localStorage.getItem(this.storageKey) === '1';
        } catch (e) {
          return false;
        }
      }

      setLiked(liked) {
        this.likeButton.setAttribute('aria-pressed', liked);
        if (!this.likeCount) return;
        // Only plain numbers like "26,808" can be incremented; "26.8K" stays as written.
        if (!/^[\d,.\s]+$/.test(this.baseCount)) return;
        const separator = this.baseCount.match(/\d([,.\s])\d{3}\b/)?.[1] ?? ',';
        const value = parseInt(this.baseCount.replace(/\D/g, ''), 10) + (liked ? 1 : 0);
        this.likeCount.textContent = value.toLocaleString('en-US').replace(/,/g, separator);
      }

      async share() {
        const url = this.dataset.shareUrl;
        if (navigator.share) {
          try {
            await navigator.share({ url, title: document.title });
          } catch (e) {}
          return;
        }
        try {
          await navigator.clipboard.writeText(url);
        } catch (e) {
          return;
        }
        const label = this.shareButton.querySelector('[data-share-label]');
        const original = label.textContent;
        label.textContent = this.shareButton.dataset.copiedLabel;
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => (label.textContent = original), 2000);
      }
    }
  );
}
